<template>
  <div>
    <div class="comp-tab">
      <comp-tab-left
        :isActived="selectedTab == 'friend'"
        @tabClicked="value => updateSelectedTab(value)"
      />
      <comp-tab-right
        :isActived="selectedTab == 'group'"
        @tabClicked="value => updateSelectedTab(value)"
      />
    </div>
  </div>
</template>

<script>
import CompTabLeft from './CompTabLeft';
import CompTabRight from './CompTabRight';

export default {
  props: {
    activedTab: String,
  },
  components: {
    'comp-tab-left': CompTabLeft,
    'comp-tab-right': CompTabRight,
  },
  data() {
    return {
      selectedTab: '',
    };
  },
  methods: {
    updateSelectedTab(value) {
      this.selectedTab = value;
      this.$emit('selectedTab', this.selectedTab);
    },
  },
  created() {
    this.selectedTab = this.activedTab;
  },
};
</script>

<style lang="scss" src="../scss/comp-tab.scss" scoped></style>



// WEBPACK FOOTER //
// src/components/CompTab.vue